<template>
  <div>
    <div class="layout__content__header layout__content__header--white">
      <app-back
        :text="'naDashboard'"
        :route="{
          name: 'dashboard',
          params: {
            customerId: selectedCustomer.customerId,
            projectId: selectedProject.projectId
          }
        }"
      />
      <h1 class="">
        {{ $t("novinky") }}
      </h1>
    </div>
    <div class="layout__content__content">
      <div class="mt-5 row">
        <div class="col-sm-12">
          <div class="layout__box news dashboard__news">
            <div class="layout__box__content">
              <news-list
                :items="items"
                :loading="loading"
                :more-button="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Back from "@/components/back.vue";
import NewsList from "@/components/news/news-list.vue";
export default {
  components: {
    "app-back": Back,
    "news-list": NewsList
  },
  data() {
    return {
      items: [],
      loading: false,
      selectedProject: JSON.parse(localStorage.getItem("selectedProject")),
      selectedCustomer: JSON.parse(localStorage.getItem("selectedCustomer"))
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale() {
      this.loadPosts();
    }
  },
  mounted() {
    this.loadPosts();
  },
  methods: {
    loadPosts() {
      this.items = [];

      !this.loading ? (this.loading = true) : (this.loading = false);
      axios
        .get(
          process.env.VUE_APP_APICMS + "/" + this.locale + "/article/dashboard",
          {
            crossdomain: true
          }
        )
        .then(response => {
          if (typeof response.data == "object") {
            this.items = response.data;
          } else {
            this.items = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.items = [];
        });
    }
  }
};
</script>

<style scoped></style>
